import { ConnectionFailedNotification } from "%notifications";
import { pushNotification } from "%error/utils";

export default function() {
  pushNotification(ConnectionFailedNotification);
}
